import React from 'react';
import { PlayerProfile, PlayerData, PlayerInjury } from '../../types/player';

interface PlayerProfileHeaderProps {
  playerProfile: PlayerProfile;
  playerData: PlayerData | null;
  playerInjuries: PlayerInjury[] | null;
  playerTransfers: any[] | null;
  playerAchievements: any[] | null;
  playerStats: any[] | null;
}

export const PlayerProfileHeader: React.FC<PlayerProfileHeaderProps> = ({
  playerProfile,
  playerData,
  playerInjuries,
  playerTransfers,
  playerAchievements,
  playerStats
}) => {
  return (
    <div className="flex justify-between items-center mb-4">
      <h2 className="text-xl font-semibold text-[#CECFD2]">Player Profile</h2>
    </div>
  );
};